import {
  SportEntityScheduleAPIResponse,
  SportEntityScheduleItem,
} from '@hooks/useSportEntitySchedule'

const isMostRecentItem = (
  items: SportEntityScheduleAPIResponse['items'],
  matchId: string
): boolean => {
  const mostRecentItem = items.find((item) => {
    return (
      item.isLive === true ||
      (item.startTime && new Date(item.startTime) >= new Date())
    )
  })

  return mostRecentItem?.matchId === matchId
}

const getMostRecentItems = (
  items: SportEntityScheduleAPIResponse['items']
): SportEntityScheduleItem[] => {
  const today = new Date().toISOString().split('T')[0]

  const mostRecentGameIndex = items.findIndex((item) => {
    return (
      item.isLive === true ||
      (item.startTime && new Date(item.startTime) >= new Date(today))
    )
  })

  if (mostRecentGameIndex === -1) {
    return items.slice(0, 5)
  }

  const start = Math.max(0, mostRecentGameIndex - 2)
  const end = Math.min(items.length, mostRecentGameIndex + 3)

  return items.slice(start, end)
}

export { getMostRecentItems, isMostRecentItem }
